import { Mail, ArrowRight } from 'lucide-react';
import { Card, ContactLink } from '../../ui';
import type { AdditionalService } from '../../../data';

export interface AdditionalServiceCardProps {
    service: AdditionalService;
}

export function AdditionalServiceCard({ service }: AdditionalServiceCardProps) {
    return (
        <Card variant="glass" className="border border-green-100 bg-green-50/50">
            <div className="flex items-start gap-4">
                <div className="flex-shrink-0 w-10 h-10 rounded-full bg-green-100 flex items-center justify-center">
                    <ArrowRight className="w-5 h-5 text-green-600" />
                </div>
                <div className="flex-1">
                    <h4 className="font-font-s font-bold text-text-color text-base mb-1">{service.title}</h4>
                    <p className="font-font-s text-gray-600 text-sm mb-2">{service.description}</p>
                    {service.email && (
                        <div className="flex items-center gap-2">
                            <Mail className="w-4 h-4 text-gray-400" />
                            <ContactLink type="email" value={service.email} showIcon={false} className="text-sm" />
                        </div>
                    )}
                </div>
            </div>
        </Card>
    );
}
